import * as Haptics from 'expo-haptics';

/**
 * Light impact haptic for toggle/switch interactions.
 * Safe to call; no-op on unsupported platforms.
 */
export function hapticTick(): void {
  try {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
  } catch {
    // Haptics not available (e.g. simulator, web)
  }
}

/**
 * Gentle success pulse for when something new is created (note, document, contact, event, etc.).
 * Uses notification success feedback. Safe to call; no-op on unsupported platforms.
 */
export function hapticCreationPulse(): void {
  try {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
  } catch {
    // Haptics not available (e.g. simulator, web)
  }
}

/**
 * Gentle two-pulse fade played when the splash screen transitions out.
 * Light tap → 80 ms pause → softer Soft tap, simulating a fading vibration.
 * Safe to call; no-op on unsupported platforms.
 */
export function hapticSplashFade(): void {
  try {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
    setTimeout(() => {
      try {
        Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Soft);
      } catch {
        // Haptics not available (e.g. simulator, web)
      }
    }, 80);
  } catch {
    // Haptics not available (e.g. simulator, web)
  }
}

/**
 * Wraps a Switch onValueChange handler to fire a light haptic tick before calling the original.
 */
export function withSwitchHaptic(fn: (value: boolean) => void): (value: boolean) => void {
  return (value: boolean) => {
    hapticTick();
    fn(value);
  };
}
